import React from 'react'
import { createIcon } from '@chakra-ui/icon'

export const VideocamIcon = createIcon({
  displayName: 'VideocamIcon',
  path: <path d="M17 10.5V6H3v12h14v-4.5l4 4v-11l-4 4z" fill="currentColor" />,
  viewBox: '0 0 24 24',
})
